import React, { useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { typeMap } from 'app/config/typesConfig';
import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import { Button, CircularProgress } from '@mic3/platform-ui';
import FormGenerator from '../Designer/Form/components/FormGenerator';
import { createEntity, updateEntity } from 'store/actions/entities/entitiesActions';
import { loadDashboardEntities } from 'store/actions/dashboard/dashboardActions';

export const AddDashboardModal = (props) => {
    const { action, selectedDashboard, setActiveTab } = props || {};
    const [formData, setFormData] = useState(action === 'Rename' ? selectedDashboard : {});
    const [isLoading, setLoading] = useState(false);
    const { data, isLoading: loadingDashbaord } = useSelector((state) => state.dashboard.dashboardEntities);

    const { onClose } = props;
    const formRef = useRef(null);
    const dispatch = useDispatch();

    const dashboards = data?.records;

    const formFields = useMemo(() => {
        return [
            {
                field: 'name',
                type: 'text',
                properties: { label: 'Dashboard name', name: 'name' },
                constraints: {
                    required: true,
                    minLength: 3,
                    maxLength: 80,
                    custom: (data) => {
                        try {
                            const name = data?.name?.trim()?.toLowerCase();
                            const result = dashboards.find((dash) => dash?.name?.trim()?.toLowerCase() === name);
                            if (name && result) {
                                return {
                                    format: {
                                        pattern: /somefaketest/,
                                        message: 'This name is already used. Please choose a different dashboard name.',
                                    },
                                };
                            }
                        } catch (error) {}
                        return {};
                    },
                },
            },
        ];
    }, [dashboards]);

    const onFormSubmit = async (event) => {
        event.preventDefault();
        try {
            const { data, errors } = await formRef.current.isValidForm();
            if (errors) {
                return;
            }
            setLoading(true);
            const func = action === 'Rename' ? updateEntity : createEntity;
            const payload = {
                name: data?.name?.trim(),
                type: typeMap.dashboard,
            };
            if (action === 'Rename') {
                payload.id = selectedDashboard?.id;
            }
            const resp = await dispatch(func(payload));
            if (resp instanceof Error) {
                return;
            }
            await dispatch(loadDashboardEntities());
            if (action !== 'Rename') {
                setActiveTab && setActiveTab(dashboards?.length || 0);
            }
            onClose();
            setLoading(false);
        } catch (error) {}
    };
    return (
        <ModalDialog
            title={`${action === 'Rename' ? 'Update' : 'Create a new'} dashboard`}
            onClose={onClose}
            actions={
                isLoading || loadingDashbaord ? (
                    <CircularProgress size={24} color='primary' />
                ) : (
                    <Button onClick={onFormSubmit}>Save</Button>
                )
            }
        >
            <FormGenerator onChange={(data) => setFormData(data)} components={formFields} ref={formRef} data={formData} />
        </ModalDialog>
    );
};
